var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCommercialBuzzer = function SvgCommercialBuzzer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 22H43c-6.075 0-11 4.925-11 11v54c0 6.075 4.925 11 11 11h34c6.075 0 11-4.925 11-11V33c0-6.075-4.925-11-11-11z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 30,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 38,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 76,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 76,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 76,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 76,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 70,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 64,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 70,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 64,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 70,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 64,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 70,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 64,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 82,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 82,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 82,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 82,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 88,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 88,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 88,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 88,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    d: "M82 59h6v12h-6z"
  })));
};

export default SvgCommercialBuzzer;